exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".numero[data-v-6d53ae3e]{font-size:14px;padding:3px 7px;width:27px;border-radius:20px}.gris[data-v-6d53ae3e]{color:#7a7a7a}.textcuenta[data-v-6d53ae3e]{font-weight:700}.is-select[data-v-6d53ae3e]{background-color:#3273dc;color:#fff}.is-error[data-v-6d53ae3e]{color:#ff3860}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d53ae3e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registrar/Viewencabezado2.vue
// module id = 694
// module chunks = 0